<template>
  <!--components/orderList/index.wxml-->
<div>
    <div v-if="mode === 'order'">
        <div class="order-list">
            <div v-for="(item, index) in orderList" :key="index">
                <div class="order-item" :class="getBackgroundColor(item.codeName)">
                    <span v-if="item.tip" class="order-tips">{{item.codeName}}</span>
                    <span class="order-status" @click="showTip(item.id)">{{ item.codeName  }}</span>
                    <div class="order-item-head">
                        <div class="order-num">
                            <span>订单号：{{item.orderId}}</span>
                            <span class="order-plus" v-if="item.plus==1">PLUS会员</span>
                        </div>
                        <div class="order-date">
                            <span>下单时间：{{item.orderTime}}</span>
                        </div>
                    </div>
                    <div class="order-item-content">
                        <div class="order-item-main">
                            <div class="order-item-left">
                                <div class="order-item-img">
                                    <img mode="scaleToFill" :src="item.goodsInfo.imageUrl" >
                                </div>
                            </div>
                            <div class="order-item-right">
                                <div class="order-item-title">
                                    <span>{{item.skuName}}</span>
                                </div>
                                <div class="order-item-rate">
                                    <!-- <div class="rate-wrap">
                                        <span class="rate-label">佣金比例</span>
                                        <span class="rate">{{item.commissionRate}}%</span>
                                    </div> -->
                                    <!-- <div class="rate-wrap">
                                        <span class="rate-label">比例分成</span>
                                        <span class="rate">{{item.subSideRate}}%</span>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="order-item-footer">
                            <div class="order-item-footer-left">
                                <div class="order-item-footer-top">
                                    <span class="footer-label">数量</span>
                                </div>
                                <div class="order-item-footer-bottom">
                                    <span>{{item.skuNum}}</span>
                                </div>
                            </div>
                            <div class="order-item-footer-mid">
                                <div class="order-item-footer-top">
                                    <span class="footer-label">预估计佣金额</span>
                                </div>
                                <div class="order-item-footer-bottom">
                                    <span>￥{{item.estimateCosPrice}}</span>
                                </div>
                            </div>
                            <div class="order-item-footer-right">
                                <div class="order-item-footer-top">
                                    <span class="footer-label">预估佣金</span>
                                </div>
                                <div class="order-item-footer-bottom">
                                    <span>￥{{item.estimateFee}}</span>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
        <div v-if="hasMore">
            <div class="load-more"><span>上滑加载更多</span></div>
        </div>
        <div v-if="!hasMore">
            <div class="load-more"><span>没有更多了</span></div>
        </div>
    </div>
    <div v-if="mode === 'settlement'">
        <div class="order-list">
            <div v-for="(item, index) in orderList" :key="index">
                <div class="order-item hidden">
                    <div class="order-item-head">
                        <div class="order-num">
                            <span>订单号：{{item.orderId}}</span>
                            <span class="order-plus" v-if="item.plus==1">PLUS会员</span>
                        </div>
                        <div class="order-date">
                            <span>下单时间：{{item.orderTime}}</span>
                        </div>
                        <div v-if="item.modifyTime" class="order-date">
                            <span>逆向发生时间：{{item.modifyTime}}</span>
                        </div>
                    </div>
                    <div class="order-item-content">
                        <div class="order-item-main">
                            <div class="order-item-left">
                                <div class="order-item-img">
                                    <img mode="scaleToFill" :src="item.goodsInfo.imageUrl">
                                </div>
                            </div>
                            <div class="order-item-right">
                                <div class="order-item-title">
                                    <!-- <span class="order-plus">{{item.unionRole}}</span> -->
                                    <span>{{item.skuName}}</span>
                                </div>
                                <div style="display: none;" class="order-item-rate">
                                    <div class="rate-wrap">
                                        <span class="rate-label">佣金比例</span>
                                        <span class="rate">{{item.commissionRate}}%</span>
                                    </div>
                                    <div class="rate-wrap">
                                        <span class="rate-label">比例分成</span>
                                        <span class="rate">{{item.subSideRate}}%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="order-item-footer">
                            <div class="order-item-footer-left">
                                <div class="order-item-footer-top">
                                    <span class="footer-label">购买数量</span>
                                </div>
                                <div class="order-item-footer-bottom">
                                    <span>{{item.skuNum}}</span>
                                </div>
                            </div>
                            <div class="order-item-footer-mid">
                                <div class="order-item-footer-top">
                                    <span class="footer-label">计佣金额</span>
                                </div>
                                <div class="order-item-footer-bottom">
                                    <span>￥{{item.actualCosPrice}}</span>
                                </div>
                            </div>
                            <div class="order-item-footer-right">
                                <div class="order-item-footer-top">
                                    <span class="footer-label">佣金变化</span>
                                </div>
                                <div class="order-item-footer-bottom">
                                    <span>￥{{item.actualFee}}</span>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>
        <div v-if="hasMore">
            <div class="load-more"><span>上滑加载更多</span></div>
        </div>
        <div v-if="!hasMore">
            <div class="load-more"><span>没有更多了</span></div>
        </div>
    </div>
</div>
</template>
<script>
export default {
  props: {
    orderList: Array,
    hasMore: Boolean,
    mode: String
  },
  data() {
    return {
    }
  },
  watch: {
    orderList(nv) {
      console.log('order 变化了', nv)
    },
  },
  created() {
  },
  methods: {
    getBackgroundColor(codeName) {
        if (codeName==='待付款') {
            return 'blue-after'
        } else if (codeName==='已付款'){
            return 'red-after' //{'background-color': 'red'}
        } else if(codeName==='已完成'){
            return 'f-after'
        } else {
            return 'o-after'
        }
    },
    setTip( id, bool ) {
      this.orderList.map( item => {
          if( id == item.id ) {
              item.tip = bool
          }
      })
    },
    showTip( id ) {
      this.setTip( id, true )
      
      let self = this
      setTimeout(() => {
          self.setTip( id, false)
      },3000)
    }
  }
}
</script>
<style scoped>
/** order list 组件样式*/
.blue-after::after{
    border-color: rgb(0, 162, 255) rgb(0, 162, 255) transparent transparent !important;
}
.red-after::after{
    border-color: rgb(238, 88, 88) rgb(238, 88, 88) transparent transparent!important;
}
.o-after::after{
    border-color: orange orange transparent transparent!important;
}
.f-after::after{
    border-color:rgb(70, 175, 70) rgb(70, 175, 70) transparent transparent!important;
}
.order-list {
    margin-top: var(--len10);
}
.order-item{
    position: relative;
}
.order-item::before{
    top: 0;
    right: 0;
    position: absolute;
    content: '';
    border-width: 1rem 1rem 1rem 1rem;
    border-color: white white transparent transparent;
    border-style: solid;
    z-index: 9;
}
.order-item::after{
    top: 0;
    right: 0;
    position: absolute;
    content: '';
    border-width: var(--len30);
    border-color: var(--primary-color) var(--primary-color) transparent transparent;
    border-style: solid;
}
.hidden::after,.hidden::before{
    display: none;
}
.order-tips{
    position: absolute;
    top: 0px;
    right: var(--len60);
    padding: 0 var(--len20);
    background-color: white;
    color: var(--primary-color);
    border: 0.5px solid var(--primary-color);
    border-radius: 3px;
    height: var(--len20);
    text-align: center;
    font-size: var(--len12);
    line-height: var(--len20);
}
.order-status{
    position: absolute;
    top: 0px;
    right: 0px;
    transform: rotate(45deg);
    z-index: 99;
    color: white;
    overflow: hidden;
    line-height: var(--len40);
    width: var(--len60);
    height: var(--len60);
    text-align: center;
    font-size: var(--len12);
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.order-item{
    padding: var(--len10);
    margin-bottom: var(--len10);
    background-color: white;
    box-sizing: border-box;
    position: relative;
}
.order-item-head{
    padding: var(--len10) 0 var(--len10) 0;
    font-size: var(--len12);
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
}
.order-item-content{
    padding: var(--len10) 0;
    display: flex;
}
.order-item-main{
    display: flex;
}
.order-item-left{
    width: var(--len80);
    height: var(--len80);
    overflow: hidden;
    margin-right: var(--len10);
}
.order-item-left img{
    width: var(--len80);
    height: var(--len80);
}
.order-item-right{
    flex: 1;
}
.order-item-footer{
    padding-bottom: var(--len10);
    display: flex;
}
.order-item-footer-left, .order-item-footer-mid, .order-item-footer-right{
    flex: 1;
    text-align: center;
}
.order-plus{
    color: white;
    background-color: var(--primary-color);
    width: var(--len50);
    height: var(--len16);
    line-height: var(--len16);
    margin-left: var(--len5);
    border-radius: var(--len3);
    padding: 0 var(--len3);
}
.order-item-right .order-item-title{
    font-size: var(--len14);
    line-height: var(--len25);
    /* font-weight: bold; */
    height: var(--len50);
    overflow: hidden;
}
.order-item-right .order-item-rate{
    font-size: var(--len14);
    height: var(--len30);
    line-height: var(--len30);
}
.order-item-rate{
    display: flex;
}
.rate-wrap{
    flex: 1;
}
.rate-label{
    font-size: var(--len12);
    color:rgba(0, 0, 0, 0.7);
}
.rate{
    margin-left: var(--len10);
    font-size: var(--len14);
    color: black;
}
.footer-label {
    color: #cccccc;
    font-size: var(--len14);
    text-align: center;
}
.order-item-footer-bottom{
  margin-top: var(--len10);
}
.load-more{
    text-align: center;
    color: #cccccc;
}
</style>